import { render, staticRenderFns } from "./TechnicalDiagnosticsSettings.vue?vue&type=template&id=3bf61756"
import script from "./TechnicalDiagnosticsSettings.vue?vue&type=script&lang=js"
export * from "./TechnicalDiagnosticsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports